import React from 'react';
import PropTypes from 'prop-types';
import './SDUI.scss';

/**
 * FieldUpdate - Displays a notification when a field is updated by AI
 *
 * @param {string} fieldId - The field identifier
 * @param {string} message - Optional update message
 * @param {number} confidence - Confidence score (0-1)
 */
export const FieldUpdate = ({ fieldId, message, confidence }) => {
  const formatFieldName = (id) => {
    return id
      .split(/[_-]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const getConfidenceLevel = (score) => {
    if (score >= 0.8) return 'high';
    if (score >= 0.5) return 'medium';
    return 'low';
  };

  const truncateMessage = (msg, maxLength = 100) => {
    if (!msg || msg.length <= maxLength) return msg;
    return msg.substring(0, maxLength) + '...';
  };

  return (
    <div className='sdui-field-update'>
      <div className='update-indicator'>
        <span className='field-name'>{formatFieldName(fieldId)}</span>
        {message && (
          <span className='update-message' title={message}>
            {truncateMessage(message)}
          </span>
        )}
        {confidence !== undefined && (
          <span
            className='confidence-badge'
            data-confidence={getConfidenceLevel(confidence)}
            title={`AI is ${Math.round(
              confidence * 100
            )}% confident about this update`}
          >
            {Math.round(confidence * 100)}%
          </span>
        )}
      </div>
    </div>
  );
};

FieldUpdate.propTypes = {
  fieldId: PropTypes.string.isRequired,
  message: PropTypes.string,
  confidence: PropTypes.number,
};

export default FieldUpdate;
